import { render, staticRenderFns } from "./CoreColumn.vue?vue&type=template&id=31c7491e&"
import script from "./CoreColumn.vue?vue&type=script&lang=js&"
export * from "./CoreColumn.vue?vue&type=script&lang=js&"
import style0 from "./CoreColumn.vue?vue&type=style&index=0&id=31c7491e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports